import { useMemo } from 'react';
import * as yup from 'yup';
import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';

export const useFormMessaging = (params = {}) => {
	const { values } = params;

	const initialValues = useMemo(() => {
		return {
			date: null,
			...values,
		};
	}, [values]);

	const shape = useMemo(() => {
		return {
			groups: [
				{
					id: 1,
					lines: [
						{
							id: 1,
							field: {
								type: FORM_LINE_TYPES.datepicker,
								connected: true,
								params: {
									name: 'date',
									label: 'Дата переписки',
								},
							},
						},
					],
				},
			],
		};
	}, []);

	const validationSchema = yup.object().shape({
		date: yup.object().required('Укажите дату'),
	});

	return { shape, initialValues, validationSchema };
};

